<template>
<v-container fluid grid-list-md style="padding: 30px;">
  <v-data-table :search="search" v-if="!addUser" :headers="headers" :items="vigilantes" sort-by="nome" class="elevation-1" style="border-radius: 10px;">
    <template v-slot:top>
      <v-toolbar flat color="white" style="border-radius: 10px;">
        <v-toolbar-title class="textoUser">VIGILANTES</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-btn text @click="criaVigilante" color="#4A148C" tile>
          <v-icon left dark>add_circle</v-icon>Cadastrar Vigilante
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="openDialog(item)">check_circle</v-icon>
        </template>
        <span>Validar</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="deleteItem(item)">delete</v-icon>
        </template>
        <span>Excluir</span>
      </v-tooltip>
    </template>
    <template slot="no-data">
      <v-row>
        <v-col>
          <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum cadastro encontrado</v-alert>
        </v-col>
      </v-row>
    </template>
    <template slot="no-results">
      <v-row>
        <v-col>
          <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{search}}" não trouxe resultados</v-alert>
        </v-col>
      </v-row>
    </template>
  </v-data-table>
  <br>
  <v-card-actions>
    <v-btn color="#7B1FA2" @click="carregaVigilantes" style="color: #ffffff">
      <v-icon left>sync</v-icon>
      Recarregar
    </v-btn>
    <!-- <v-btn color="#7B1FA2" @click="print" style="color: #ffffff">
      <v-icon left>print</v-icon>Imprimir
    </v-btn> -->
  </v-card-actions>
  <!-- DIÁLOGO PARA ADICIONAR OU EDITAR VIGILANTES -->
  <v-dialog v-model="cadastroVigilante" max-width="900px" persistent>
    <v-card style="border-radius: 10px;">
      <v-card-title>
        <span class="textoUser">{{ formTitle }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-stepper v-model="passos">
            <v-stepper-header>
              <v-stepper-step :complete="passos > 1" step="1" :editable="editaPassos">Dados Pessoais</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="passos > 2" step="2" :editable="editaPassos">Endereço</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" :editable="editaPassos">Anexos</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card class="mb-12">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="8">
                      <v-text-field v-model="editedItem.nome" dense outlined label="Nome" color="#7B1FA2" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="4">
                      <v-text-field v-model="editedItem.cpf" dense outlined label="CPF" color="#7B1FA2" hide-details ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="3">
                      <v-text-field v-model="editedItem.dataNascimento" dense outlined label="Data de Nascimento" color="#7B1FA2" hide-details v-mask="'##/##/####'"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="3">
                      <v-select v-model="editedItem.sexo" dense outlined label="Sexo" color="#7B1FA2" :items="sexos" hide-details item-text="text" item-value="value"></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="3">
                      <v-text-field v-model="editedItem.telefone" dense outlined label="Telefone" color="#7B1FA2" hide-details v-mask="'(##) #####-####'"></v-text-field >
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="3">
                      <v-text-field v-model="editedItem.codigo" dense outlined label="Código" color="#7B1FA2" hide-details disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="6">
                      <v-text-field v-model="editedItem.email" dense outlined label="E-mail" color="#7B1FA2" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="6">
                      <v-select v-model="editedItem.qualificacao" dense outlined label="Qualificação" color="#7B1FA2" :items="qualificacoes" hide-details item-text="text" item-value="value"></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="6">
                      <v-text-field v-model="editedItem.validadeCurso" dense outlined label="Vencimento Reciclagem" color="#7B1FA2" v-mask="'##/##/####'" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="6">
                      <v-text-field v-model="editedItem.ultimaConsultaPF" dense outlined label="Última Consulta PF" color="#7B1FA2" v-mask="'##/##/####'" hide-details></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card-actions v-if="editedIndex == -1">
                  <v-spacer></v-spacer>
                  <v-btn color="#4A148C" class="cssBotao" dark @click="avancaPasso2">Continuar</v-btn>
                  <v-btn color="#BA68C8" class="cssBotao" dark @click="close">Cancelar</v-btn>
                </v-card-actions>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card class="mb-12">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="4">
                      <v-text-field light v-model="editedItem.cep" label="CEP" outlined color="#00695C" dense hide-details required v-mask="'#####-###'" @blur="retornoCEP()" append-outer-icon="search"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="6">
                      <v-text-field v-model="editedItem.logradouro" dense outlined label="Rua" color="#7B1FA2" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="2">
                      <v-text-field v-model="editedItem.numero" dense outlined label="Número" color="#7B1FA2" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="4">
                      <v-text-field v-model="editedItem.estado" dense outlined label="Estado" color="#7B1FA2" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="4">
                      <v-text-field v-model="editedItem.cidade" dense outlined label="Cidade" color="#7B1FA2" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="4">
                      <v-text-field v-model="editedItem.bairro" dense outlined label="Bairro" color="#7B1FA2" hide-details></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card-actions v-if="editedIndex == -1">
                  <v-btn color="#4A148C" class="cssBotao" dark @click="avancaPasso3">Continuar</v-btn>
                  <v-btn color="#BA68C8" class="cssBotao" dark @click="close">Cancelar</v-btn>
                </v-card-actions>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-card class="mb-12">
                  <!-- COMPROVANTE DE RECICLAGEM -->
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <v-card elevation="6">
                      <iframe v-if="editedItem.arquivoComprovanteReciclagem != '' && editedItem.arquivoComprovanteReciclagem.substring(0,10) == 'data:appli'" :src="editedItem.arquivoComprovanteReciclagem" height="130px"></iframe>
                      <v-img v-if="editedItem.arquivoComprovanteReciclagem != '' && editedItem.arquivoComprovanteReciclagem.substring(0,10) == 'data:image'" :src="editedItem.arquivoComprovanteReciclagem" height="130px"></v-img>
                      <v-alert v-if="editedItem.arquivoComprovanteReciclagem == ''" dark dense text outlined :value="true" color="warning" icon="info" prominent>Nenhum anexo enviado</v-alert>
                      <v-card-title style="font-size: 17px">COMPROVANTE RECICLAGEM</v-card-title>
                      <v-card-actions>
                        <v-btn v-if="editedItem.arquivoComprovanteReciclagem != ''" color="#7B1FA2" @click="visualizaImagem(editedItem.arquivoComprovanteReciclagem, editedItem.arquivoComprovanteReciclagem.substring(0,10))" text>Visualizar</v-btn>
                        <v-btn v-if="editedItem.arquivoComprovanteReciclagem != ''" color="#7B1FA2" @click="uploadComprovanteReciclagem = true" text>Alterar</v-btn>
                        <v-btn v-else color="#7B1FA2" @click="uploadComprovanteReciclagem = true" text>Enviar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                  <br>
                  <!-- RG FRENTE -->
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <v-card elevation="6">
                      <iframe v-if="editedItem.arquivoRgFrente != '' && editedItem.arquivoRgFrente.substring(0,10) == 'data:appli'" :src="editedItem.arquivoRgFrente" height="130px"></iframe>
                      <v-img v-if="editedItem.arquivoRgFrente != '' && editedItem.arquivoRgFrente.substring(0,10) == 'data:image'" :src="editedItem.arquivoRgFrente" height="130px"></v-img>
                      <v-alert v-if="editedItem.arquivoRgFrente == ''" dark dense text outlined :value="true" color="warning" icon="info" prominent>Nenhum anexo enviado</v-alert>
                      <v-card-title style="font-size: 17px">RG/CNH (FRENTE)</v-card-title>
                      <v-card-actions>
                        <v-btn v-if="editedItem.arquivoRgFrente != ''" color="#7B1FA2" @click="visualizaImagem(editedItem.arquivoRgFrente, editedItem.arquivoRgFrente.substring(0,10))" text>Visualizar</v-btn>
                        <v-btn v-if="editedItem.arquivoRgFrente != ''" color="#7B1FA2" @click="uploadCnhRgFrente = true" text>Alterar</v-btn>
                        <v-btn v-else color="#7B1FA2" @click="uploadCnhRgFrente = true" text>Enviar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                  <br>
                  <!-- RG VERSO -->
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <v-card elevation="6">
                      <iframe v-if="editedItem.arquivoRgVerso != '' && editedItem.arquivoRgVerso.substring(0,10) == 'data:appli'" :src="editedItem.arquivoRgVerso" height="130px"></iframe>
                      <v-img v-if="editedItem.arquivoRgVerso != '' && editedItem.arquivoRgVerso.substring(0,10) == 'data:image'" :src="editedItem.arquivoRgVerso" height="130px"></v-img>
                      <v-alert v-if="editedItem.arquivoRgVerso == ''" dark dense text outlined :value="true" color="warning" icon="info" prominent>Nenhum anexo enviado</v-alert>
                      <v-card-title style="font-size: 17px">RG/CNH (VERSO)</v-card-title>
                      <v-card-actions>
                        <v-btn v-if="editedItem.arquivoRgVerso != ''" color="#7B1FA2" @click="visualizaImagem(editedItem.arquivoRgVerso, editedItem.arquivoRgVerso.substring(0,10))" text>Visualizar</v-btn>
                        <v-btn v-if="editedItem.arquivoRgVerso != ''" color="#7B1FA2" @click="uploadCnhRgVerso = true" text>Alterar</v-btn>
                        <v-btn v-else color="#7B1FA2" @click="uploadCnhRgVerso = true" text>Enviar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                  <br>
                  <!-- CPF -->
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <v-card elevation="6">
                      <iframe v-if="editedItem.arquivoCpf != '' && editedItem.arquivoCpf.substring(0,10) == 'data:appli'" :src="editedItem.arquivoCpf" height="130px"></iframe>
                      <v-img v-if="editedItem.arquivoCpf != '' && editedItem.arquivoCpf.substring(0,10) == 'data:image'" :src="editedItem.arquivoCpf" height="130px"></v-img>
                      <v-alert v-if="editedItem.arquivoCpf == ''" dark dense text outlined :value="true" color="warning" icon="info" prominent>Nenhum anexo enviado</v-alert>
                      <v-card-title style="font-size: 17px">CPF</v-card-title>
                      <v-card-actions>
                        <v-btn v-if="editedItem.arquivoCpf != ''" color="#7B1FA2" @click="visualizaImagem(editedItem.arquivoCpf, editedItem.arquivoCpf.substring(0,10))" text>Visualizar</v-btn>
                        <v-btn v-if="editedItem.arquivoCpf != ''" color="#7B1FA2" @click="uploadCpf = true" text>Alterar</v-btn>
                        <v-btn v-else color="#7B1FA2" @click="uploadCpf = true" text>Enviar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                  <br>
                  <!-- FOTO PESSOAL -->
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <v-card elevation="6">
                      <iframe v-if="editedItem.arquivoFotoPessoal != '' && editedItem.arquivoFotoPessoal.substring(0,10) == 'data:appli'" :src="editedItem.arquivoFotoPessoal" height="130px"></iframe>
                      <v-img v-if="editedItem.arquivoFotoPessoal != '' && editedItem.arquivoCpf.substring(0,10) == 'data:image'" :src="editedItem.arquivoFotoPessoal" height="130px"></v-img>
                      <v-alert v-if="editedItem.arquivoFotoPessoal == ''" dark dense text outlined :value="true" color="warning" icon="info" prominent>Nenhum anexo enviado</v-alert>
                      <v-card-title style="font-size: 17px">FOTO PESSOAL</v-card-title>
                      <v-card-actions>
                        <v-btn v-if="editedItem.arquivoFotoPessoal != ''" color="#7B1FA2" @click="visualizaImagem(editedItem.arquivoFotoPessoal, editedItem.arquivoFotoPessoal.substring(0,10))" text>Visualizar</v-btn>
                        <v-btn v-if="editedItem.arquivoFotoPessoal != ''" color="#7B1FA2" @click="uploadFotoPessoal = true" text>Alterar</v-btn>
                        <v-btn v-else color="#7B1FA2" @click="uploadFotoPessoal = true" text>Enviar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-card>
                <v-card-actions v-if="editedIndex == -1">
                  <v-btn color="#4A148C" class="cssBotao" dark @click="inscricaoVigilante">Continuar</v-btn>
                  <v-btn color="#BA68C8" class="cssBotao" dark @click="close">Cancelar</v-btn>
                </v-card-actions>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="editedIndex != -1">
        <v-spacer></v-spacer>
        <v-btn color="#4A148C" class="cssBotao" dark @click="save">Salvar</v-btn>
        <v-btn color="#BA68C8" class="cssBotao" dark @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- FIM DO DIÁLOGO PARA ADICIONAR OU EDITAR VIGILANTES -->
  <!-- DIÁLOGO ENVIO FRENTE RG/CNH -->
  <v-dialog v-model="uploadCnhRgFrente" max-width="550px" max-height="300px" persistent> 
    <v-card style="border-radius: 10px;">
      <v-container grid-list-md>
        <v-layout row wrap justify-center>
          <v-container fill-height fluid pa-1 justify-center>
            <vueAnkaCropper
              :options="{
                aspectRatio: 1,
                closeOnSave: true,
                cropArea: 'box',
                croppedHeight: 500,
                croppedWidth: 500,
                cropperHeight: false,
                dropareaMessage: 'Insira aqui uma imagem da frente de seu RG/CNH',
                frameLineDash: [0,0],
                frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                handleFillColor: 'rgba(255, 255, 255, 0.2)',
                handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                handleSize: 10,
                handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                layoutBreakpoint: 500,
                maxCropperHeight: 768,
                maxFileSize: 8000000,
                overlayFill: 'rgba(0, 0, 0, 0.5)',
                previewOnDrag: false,
                previewQuality: 0.65,
                resultQuality: 0.9,
                resultMimeType: 'image/jpeg',
                selectButtonLabel: 'Escolher imagem',
                showPreview: false,
                skin: 'light',
                uploadData: {},
                uploadTo: false
              }"
              @cropper-error="erroCorte($event)"
              @cropper-saved="salvarCorte($event, 1)"
              @cropper-cancelled="cancelaCorte()"
            ></vueAnkaCropper>
          </v-container>
        </v-layout>
        <v-card-actions>
          <v-container fill-height fluid pa-1 justify-center>
            <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadCnhRgFrente = false">Fechar</v-btn>
          </v-container>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
  <!-- DIÁLOGO ENVIO VERSO RG/CNH -->
  <v-dialog v-model="uploadCnhRgVerso" max-width="550px" max-height="300px" persistent> 
    <v-card style="border-radius: 10px;">
      <v-container grid-list-md>
        <v-layout row wrap justify-center>
          <v-container fill-height fluid pa-1 justify-center>
            <vueAnkaCropper
              :options="{
                aspectRatio: 1,
                closeOnSave: true,
                cropArea: 'box',
                croppedHeight: 500,
                croppedWidth: 500,
                cropperHeight: false,
                dropareaMessage: 'Insira aqui uma imagem do verso de seu RG/CNH',
                frameLineDash: [0,0],
                frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                handleFillColor: 'rgba(255, 255, 255, 0.2)',
                handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                handleSize: 10,
                handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                layoutBreakpoint: 500,
                maxCropperHeight: 768,
                maxFileSize: 8000000,
                overlayFill: 'rgba(0, 0, 0, 0.5)',
                previewOnDrag: false,
                previewQuality: 0.65,
                resultQuality: 0.9,
                resultMimeType: 'image/jpeg',
                selectButtonLabel: 'Escolher imagem',
                showPreview: false,
                skin: 'light',
                uploadData: {},
                uploadTo: false
              }"
              @cropper-error="erroCorte($event)"
              @cropper-saved="salvarCorte($event, 2)"
              @cropper-cancelled="cancelaCorte()"
            ></vueAnkaCropper>
          </v-container>
        </v-layout>
        <v-card-actions>
          <v-container fill-height fluid pa-1 justify-center>
            <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadCnhRgVerso = false">Fechar</v-btn>
          </v-container>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
  <!-- DIÁLOGO ENVIO CPF -->
  <v-dialog v-model="uploadCpf" max-width="550px" max-height="300px" persistent> 
    <v-card style="border-radius: 10px;">
      <v-container grid-list-md>
        <v-layout row wrap justify-center>
          <v-container fill-height fluid pa-1 justify-center>
            <vueAnkaCropper
              :options="{
                aspectRatio: 1,
                closeOnSave: true,
                cropArea: 'box',
                croppedHeight: 500,
                croppedWidth: 500,
                cropperHeight: false,
                dropareaMessage: 'Insira aqui uma imagem do CPF',
                frameLineDash: [0,0],
                frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                handleFillColor: 'rgba(255, 255, 255, 0.2)',
                handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                handleSize: 10,
                handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                layoutBreakpoint: 500,
                maxCropperHeight: 768,
                maxFileSize: 8000000,
                overlayFill: 'rgba(0, 0, 0, 0.5)',
                previewOnDrag: false,
                previewQuality: 0.65,
                resultQuality: 0.9,
                resultMimeType: 'image/jpeg',
                selectButtonLabel: 'Escolher imagem',
                showPreview: false,
                skin: 'light',
                uploadData: {},
                uploadTo: false
              }"
              @cropper-error="erroCorte($event)"
              @cropper-saved="salvarCorte($event, 3)"
              @cropper-cancelled="cancelaCorte()"
            ></vueAnkaCropper>
          </v-container>
        </v-layout>
        <v-card-actions>
          <v-container fill-height fluid pa-1 justify-center>
            <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadCpf = false">Fechar</v-btn>
          </v-container>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
  <!-- DIÁLOGO ENVIO FOTO PESSOAL -->
  <v-dialog v-model="uploadFotoPessoal" max-width="550px" max-height="300px" persistent> 
    <v-card style="border-radius: 10px;">
      <v-container grid-list-md>
        <v-layout row wrap justify-center>
          <v-container fill-height fluid pa-1 justify-center>
            <vueAnkaCropper
              :options="{
                aspectRatio: 1,
                closeOnSave: true,
                cropArea: 'box',
                croppedHeight: 500,
                croppedWidth: 500,
                cropperHeight: false,
                dropareaMessage: 'Insira aqui sua foto pessoal do rosto',
                frameLineDash: [0,0],
                frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                handleFillColor: 'rgba(255, 255, 255, 0.2)',
                handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                handleSize: 10,
                handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                layoutBreakpoint: 500,
                maxCropperHeight: 768,
                maxFileSize: 8000000,
                overlayFill: 'rgba(0, 0, 0, 0.5)',
                previewOnDrag: false,
                previewQuality: 0.65,
                resultQuality: 0.9,
                resultMimeType: 'image/jpeg',
                selectButtonLabel: 'Escolher imagem',
                showPreview: false,
                skin: 'light',
                uploadData: {},
                uploadTo: false
              }"
              @cropper-error="erroCorte($event)"
              @cropper-saved="salvarCorte($event, 4)"
              @cropper-cancelled="cancelaCorte()"
            ></vueAnkaCropper>
          </v-container>
        </v-layout>
        <v-card-actions>
          <v-container fill-height fluid pa-1 justify-center>
            <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadFotoPessoal = false">Fechar</v-btn>
          </v-container>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
  <!-- DIÁLOGO ENVIO COMPROVANTE RECICLAGEM -->
  <v-dialog v-model="uploadComprovanteReciclagem" max-width="550px" max-height="300px" persistent> 
    <v-card style="border-radius: 10px;">
      <v-container grid-list-md>
        <v-layout row wrap justify-center>
          <v-container fill-height fluid pa-1 justify-center>
            <vueAnkaCropper
              :options="{
                aspectRatio: 1,
                closeOnSave: true,
                cropArea: 'box',
                croppedHeight: 500,
                croppedWidth: 500,
                cropperHeight: false,
                dropareaMessage: 'Insira aqui o print do comprovante de reciclagem',
                frameLineDash: [0,0],
                frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                handleFillColor: 'rgba(255, 255, 255, 0.2)',
                handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                handleSize: 10,
                handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                layoutBreakpoint: 500,
                maxCropperHeight: 768,
                maxFileSize: 8000000,
                overlayFill: 'rgba(0, 0, 0, 0.5)',
                previewOnDrag: false,
                previewQuality: 0.65,
                resultQuality: 0.9,
                resultMimeType: 'image/jpeg',
                selectButtonLabel: 'Escolher imagem',
                showPreview: false,
                skin: 'light',
                uploadData: {},
                uploadTo: false
              }"
              @cropper-error="erroCorte($event)"
              @cropper-saved="salvarCorte($event, 5)"
              @cropper-cancelled="cancelaCorte()"
            ></vueAnkaCropper>
          </v-container>
        </v-layout>
        <v-card-actions>
          <v-container fill-height fluid pa-1 justify-center>
            <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadComprovanteReciclagem = false">Fechar</v-btn>
          </v-container>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
  <v-dialog v-model="visualizaAnexo" max-width="600px" persistent> 
    <v-card style="border-radius: 10px;">
      <v-container grid-list-md>
        <v-layout row wrap justify-center>
          <v-container v-if="!arquivoPdf" fill-height fluid pa-1 justify-center>
            <img :src="imagem" width="300px">
          </v-container>
          <v-container v-if="arquivoPdf" fill-height fluid pa-1 justify-center>
            <iframe :src="pdf" height="400px" width="500px"></iframe>
          </v-container>
        </v-layout>
        <v-card-actions>
          <v-container fill-height fluid pa-1 justify-center>
            <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="visualizaAnexo = false">Fechar</v-btn>
          </v-container>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
  <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
  <Snackbar ref=chamaSnackbar />
  <!-- <div v-show="true">
    <Inscricoes ref="inscricoes"></Inscricoes>
  </div> -->
</v-container>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
// import Inscricoes from '../componentes/inscricoes.vue'
import moment from 'moment'
import axios from 'axios'
import { mapState } from 'vuex'
import CpfValidate from '../componentes/validators/rules/cpf'
import vueAnkaCropper from 'vue-anka-cropper'
export default {
  components: {
    Snackbar,
    Loading,
    vueAnkaCropper,
    /*Inscricoes,*/
  },
  data: () => ({
    imagem: '',
    pdf: '',
    arquivoPdf: false,
    uploadCnhRgFrente: false,
    uploadCnhRgVerso: false,
    uploadCpf: false,
    uploadFotoPessoal: false,
    uploadComprovanteReciclagem: false,
    visualizaAnexo: false,
    cadastroVigilante: false,
    eventoId: '',
    eventoIdAtual: '',
    fullPage: true,
    isLoading: false,
    loading: false,
    search: '',
    nome: '',
    addUser: false,
    dialog: false,
    qualificacoes: ['APOIO', 'VIGILANTE BÁSICO', 'VIGILANTE DE GRANDES EVENTOS'],
    sexos: ['MASCULINO', 'FEMININO'],
    headers: [
      { text: 'Nome', align: 'start', value: 'nome' },
      { text: 'CPF', value: 'cpf' },
      { text: 'Sexo', value: 'sexo' },
      { text: 'Data de Nascimento', value: 'dataNascimento' },
      { text: 'Estado', value: 'estado' },
      { text: 'Cidade', value: 'cidade' },
      { text: 'Telefone', value: 'telefone' },
      { text: 'Qualificação', value: 'qualificacao' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Curso', value: 'validadeCurso' },
      { text: 'Realizada em', value: 'created' },
      { text: 'Ações', value: 'action', align: 'center', sortable: true }
    ],
    editedIndex: -1,
    editedItem: {
      cod_incricao: '',
      nome: "",
      cpf: "",
      sexo: "",
      telefone: "",
      logradouro: '',
      numero: '',
      estado: '',
      cidade: '',
      bairro: '',
      email: "",
      dataNascimento: "",
      empresaId: "",
      cep: '',
      codigo: '',
      qualificacao: "",
      validadeCurso: "",
      arquivoCpf: '',
      arquivoCnh: '',
      arquivoRgFrente: '',
      arquivoRgVerso: '',
      arquivoComprovanteReciclagem: '',
      arquivoFotoPessoal: '',
      ultimaConsultaPF: '',
      id: "",
    },
    defaultEditedItem: {
      cod_incricao: '',
      nome: "",
      cpf: "",
      sexo: "",
      telefone: "",
      logradouro: '',
      numero: '',
      estado: '',
      cidade: '',
      bairro: '',
      email: "",
      dataNascimento: "",
      empresaId: "",
      cep: '',
      codigo: '',
      qualificacao: "",
      validadeCurso: "",
      arquivoCpf: '',
      arquivoCnh: '',
      arquivoRgFrente: '',
      arquivoRgVerso: '',
      arquivoComprovanteReciclagem: '',
      arquivoFotoPessoal: '',
      ultimaConsultaPF: '',
      id: "",
    },
    eventos: [],
    vigilantes: [],
    editaPassos: false,
    passos: 1,
    filesRg1: [],
    filesRg2: [],
    filesCpf: [],
    filesReciclagem: [],
    filesPessoal: [],
  }),

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR VIGILANTE' : 'EDITAR VIGILANTE'
    }
  }),

  mounted() {
    this.carregaVigilantes()
  },

  methods: {
    visualizaImagem(base64, tipo) {
      if (tipo == 'data:appli') {
        this.arquivoPdf = true
        this.pdf = base64
      } else if (tipo == 'data:image') {
        this.arquivoPdf = false
        this.imagem = base64
      }
      this.visualizaAnexo = true
    },

    async retornoCEP() {
      if (/^[0-9]{5}-[0-9]{3}$/.test(this.editedItem.cep)) {
        this.isLoading = true
        try {
          let res = await axios.get(`https://viacep.com.br/ws/${this.editedItem.cep.replace(/[^\d]+/g,'')}/json/`) 
          if (res.data.erro == true || res.data.bairro == '' || res.data.localidade == '' || res.data.uf == '') {
            this.isLoading = false
            var vmcep = this;
            vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
          } else {
            this.editedItem.logradouro = res.data.logradouro.toUpperCase()
            this.editedItem.estado = res.data.uf.toUpperCase()
            this.editedItem.cidade = res.data.localidade.toUpperCase()
            this.editedItem.bairro = res.data.bairro.toUpperCase()
            this.isLoading = false
          }
        } catch (error) {
          this.isLoading = false
          vmcep = this;
          vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
          this.editedItem.logradouro = ''
          this.editedItem.estado = ''
          this.editedItem.cidade = ''
          this.editedItem.bairro = ''
        }
      } /* else {
        this.isLoading = false
        vmcep = this;
        vmcep.$refs.chamaSnackbar.snack("#F9A825","Insira um CEP válido!","ATENÇÃO")
        this.editedItem.logradouro = ''
        this.editedItem.estado = ''
        this.editedItem.cidade = ''
        this.editedItem.bairro = ''
      } */
    },

    preparaImpressao() {
      var pr = this;
      pr.$refs.inscricoes.preparaImpressao()
    },

    print() {
      var vm = this;
      vm.$refs.inscricoes.print();
    },

    async save() {
      this.isLoading = true
      if (this.editedIndex != -1) {
        // editando vigilante
        this.editedItem.nome = this.editedItem.nome
        this.editedItem.cpf = this.editedItem.cpf
        if(this.editedItem.email != undefined)
        this.editedItem.email = this.editedItem.email.trim().toLowerCase()
        this.editedItem.empresaId = this.companyobj.id
        await axios.put(`${baseApiUrl}Vigilantes/${this.editedItem.id}`, this.editedItem).then(res => {
          if (res.data != null) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaVigilantes()
          }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
      } else {
        // criando vigilante
        this.editedItem.empresaId = this.companyobj.id
        if(this.editedItem.email != undefined)
        this.editedItem.email = this.editedItem.email.trim().toLowerCase()
        await axios.post(`${baseApiUrl}Vigilantes/salvaVigilante`, this.editedItem)
        .then(res => {
          this.id_evento = res.data.id
          if (res.data) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Vigilante cadastrado com sucesso!", "INFORMAÇÃO")
            this.carregaVigilantes()
          }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar vigilante, tente novamente", "ERRO")
        })
      }
      this.close()
    },

    compare(a) {
      // Use toUpperCase() to ignore character casing
      const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
      //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
      const dataC = moment().format()

      let comparison = 0;
      if (dataC >= dataA)
        comparison = 1;
      /* else
        if (dataA >= dataC && dataB < dataA)
          comparison = -1; */
      else
      if (dataC < dataA)
        comparison = -1;
      return comparison;
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHour(data_hora) {
      let data = data_hora.substr(0, 10).split('-')
      data = data[2] + '/' + data[1] + '/' + data[0]
      let hora = data_hora.substr(11, 8)

      return data + ' ' + hora

    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatoData(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    async carregaVigilantes() {
      this.isLoading = true
      await axios.get(`${baseApiUrl}Vigilantes?filter={"fields":{"nome":true,"cpf":true,"sexo":true,"dataNascimento":true,"estado":true,"cidade":true,"telefone":true,"qualificacao":true,"situacao":true,"validadeCurso":true,"created":true,"id":true}}`).then(res => {
        this.vigilantes = []
        sessionStorage.setItem('Vigilantes',JSON.stringify(res.data))
        for (var key in res.data) {
          if (res.data.hasOwnProperty(key)) {
            this.vigilantes.push({
              'cod_incricao': res.data[key].cod_incricao,
              'nome': res.data[key].nome,
              'cpf': res.data[key].cpf,
              'sexo': res.data[key].sexo,
              'telefone': res.data[key].telefone,
              'estado': res.data[key].estado,
              'cidade': res.data[key].cidade,
              'dataNascimento': res.data[key].dataNascimento,
              'qualificacao': res.data[key].qualificacao,
              'created': moment(res.data[key].created).format("DD/MM/YYYY HH:mm:ss"),
              'situacao': res.data[key].situacao,
              'validadeCurso': this.verificaVencimento(res.data[key].validadeCurso),
              'id': res.data[key].id
            });
          }
        }
        this.isLoading = false
        // this.preparaImpressao()
      })
    },

    verificaVencimento (data) {
      if (data) {
        if (moment(this.formatoData(data)).isAfter() == true) {
          return 'EM DIA'
        } else if (moment(this.formatoData(data)).isAfter() == false) {
          return 'VENCIDO'
        }
      }
    },

    async openDialog(item) {
      if (item.situacao == 'EM ANÁLISE') {
        var r = confirm('Deseja ativar o cadastro do(a) vigilante ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.patch(`${baseApiUrl}Vigilantes/${item.id}`, {"situacao":"ATIVO"})
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaVigilantes()
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
        }
      } else if (item.situacao == 'ATIVO') {
        r = confirm('O vigilante ' + item.nome + ' encontra-se com situação ATIVO. Deseja alterar para BLOQUEADO?')
        if (r == true) {
          this.isLoading = true
          await axios.patch(`${baseApiUrl}Vigilantes/${item.id}`, {"situacao":"BLOQUEADO"})
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaVigilantes()
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
        }
      } else if (item.situacao == 'BLOQUEADO') {
        r = confirm('O vigilante ' + item.nome + ' encontra-se com situação BLOQUEADO. Deseja alterar para ATIVO?')
        if (r == true) {
          this.isLoading = true
          await axios.patch(`${baseApiUrl}Vigilantes/${item.id}`, {"situacao":"ATIVO"})
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaVigilantes()
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
        }
      }
    },

    async editItem(item) {
      this.isLoading = true
      try {
        await axios.get(`${baseApiUrl}Vigilantes/${item.id}`).then(response => {
          if (response.data) {
            this.editaPassos = true
            this.editedIndex = this.vigilantes.indexOf(item)
            this.editedItem = Object.assign({}, response.data)
            this.cadastroVigilante = true
            this.isLoading = false
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
      }
    },

    criaVigilante() {
      this.editaPassos = false
      this.editedIndex = -1
      this.cadastroVigilante = true
    },

    async deleteItem(item) {
      var r = confirm('Deseja realmente excluir ' + item.nome + '?')
      if (r == true) {
        this.isLoading = true
        await axios.delete(`${baseApiUrl}Vigilantes/${item.id}`)
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaVigilantes()
            //this.eventoId = this.eventoIdAtual
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
      }
    },

    close() {
      this.dialog = false
      this.cadastroVigilante = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultEditedItem)
        this.editedIndex = -1
        this.passos = 1
      }, 300)
    },

    avancaPasso2() {
      if (this.editedItem.nome != '' && this.editedItem.cpf != '' && this.editedItem.dataNascimento != '' && this.editedItem.sexo != '' && this.editedItem.telefone != '' && this.editedItem.email != '' && this.editedItem.qualificacao != '' && this.editedItem.vencimentoCurso != '') {
        this.passos = 2
      } else {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos!", "ATENÇÃO")
      }
    },

    avancaPasso3() {
      if (this.editedItem.cep != '' && this.editedItem.logradouro != '' && this.editedItem.numero != '' && this.editedItem.estado != '' && this.editedItem.cidade != '' && this.editedItem.bairro != '') {
        this.passos = 3
      } else {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos!", "ATENÇÃO")
      }
    },

    async inscricaoVigilante() {
      var vm = this;
      if (this.editedItem.qualificacao != 'APOIO') {
        if (
          (this.editedItem.nome == '') || (!CpfValidate(this.editedItem.cpf)) || (this.editedItem.sexo == '') || (this.editedItem.telefone == '') ||
          (this.editedItem.cep == '') || (this.editedItem.logradouro == '') || (this.editedItem.numero == '') || (this.editedItem.email == '') ||
          (this.editedItem.dataNascimento == '') || (this.editedItem.qualificacao == '') || (this.editedItem.validadeCurso == '')) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos!","ATENÇÃO")
        } else {
          this.editedItem.arquivoRgFrente = document.getElementById("rg1").value
          this.editedItem.arquivoRgVerso = document.getElementById("rg2").value
          this.editedItem.arquivoCpf = document.getElementById("cpf").value          
          this.editedItem.arquivoComprovanteReciclagem = document.getElementById("reciclagem").value
          this.editedItem.arquivoFotoPessoal = document.getElementById("pessoal").value
          if (this.editedItem.arquivoRgFrente == undefined || this.editedItem.arquivoRgVerso == undefined || this.editedItem.arquivoCpf == undefined || this.editedItem.arquivoCnh == undefined || this.editedItem.arquivoComprovanteReciclagem == undefined || this.editedItem.arquivoFotoPessoal == undefined) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário enviar todos os arquivos!","ATENÇÃO")
          } else {
            try {
              this.isLoading = true
              await axios.post(`${baseApiUrl}Vigilantes/salvaVigilante`, this.editedItem).then(res => {
                if (res.data) {
                  this.isLoading = false
                  var vm = this
                  vm.$refs.chamaSnackbar.snack("#0288D1", "Cadastro realizado com sucesso!", "INFORMAÇÃO")
                }
              })
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar inscrição. Tente novamente.", "DESCULPE")
            }
          }
        }
      } else {
        if (
        (this.editedItem.nome == '') || (!CpfValidate(this.editedItem.cpf)) || (this.editedItem.sexo == '') || (this.editedItem.telefone == '') ||
        (this.editedItem.cep == '') || (this.editedItem.logradouro == '') || (this.editedItem.numero == '') || (this.editedItem.email == '') ||
        (this.editedItem.dataNascimento == '') || (this.editedItem.qualificacao == '')) {        
          vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos!","ATENÇÃO")
        } else {
          this.editedItem.arquivoRgFrente = document.getElementById("rg1").value
          this.editedItem.arquivoRgVerso = document.getElementById("rg2").value
          this.editedItem.arquivoCpf = document.getElementById("cpf").value          
          this.editedItem.arquivoFotoPessoal = document.getElementById("pessoal").value 
          if (this.editedItem.arquivoRgFrente == undefined || this.editedItem.arquivoRgVerso == undefined || this.editedItem.arquivoCpf == undefined || this.editedItem.arquivoCnh == undefined || this.editedItem.arquivoFotoPessoal == undefined) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário enviar todos os arquivos!","ATENÇÃO")
          } else {
            try {
              this.isLoading = true
              await axios.post(`${baseApiUrl}Vigilantes/salvaVigilante`, this.editedItem).then(res => {
                if (res.data) {
                  this.isLoading = false
                  var vm = this
                  vm.$refs.chamaSnackbar.snack("#0288D1", "Cadastro realizado com sucesso!", "INFORMAÇÃO")
                }
              })
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar inscrição. Tente novamente.", "DESCULPE")
            }
          }
        }
      }
    },

    cancelaCorte() {
      this.uploadCnhRgFrente = false
      this.uploadCnhRgVerso = false
      this.uploadCpf = false
      this.uploadFotoPessoal = false
    },

    async salvarCorte(event, field) {
      this.isLoading = true
      if (field == 1) {
        this.editedItem.arquivoRgFrente = event.croppedImageURI
      }
      else if (field == 2) {
        this.editedItem.arquivoRgVerso = event.croppedImageURI
      }
      else if (field == 3) {
        this.editedItem.arquivoCpf = event.croppedImageURI
      }
      else if (field == 4) {
        this.editedItem.arquivoFotoPessoal = event.croppedImageURI
      }
      else if (field == 5) {
        this.editedItem.arquivoComprovanteReciclagem = event.croppedImageURI
      }
      this.uploadPhoto = false
      this.uploadCnhRgFrente = false
      this.uploadCnhRgVerso = false
      this.uploadCpf = false
      this.uploadFotoPessoal = false
      this.uploadComprovanteReciclagem = false
      this.isLoading = false
      var vm = this;
      vm.$refs.chamaSnackbar.snack("#87F500","Imagem salva!","SUCESSO");
    },

    erroCorte (event) {
      if (event.substring(0,5) == "Wrong") {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825","Apenas imagens são permitidas!","ATENÇÃO");
      }
      else if (event.substring(0,4) == "File") {
        vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825","Arquivo muito grande. Máximo permitido de 8MB","ATENÇÃO");
      }
    },
  },
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

@font-face {
  font-family: Roboto;
  src: url('https://fonts.google.com/specimen/Roboto');
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 120px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
